import PageLayout from "Layouts/PageLayout";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import React from "react";
import { TagForm } from "Features/Tags";
import TagIcon from "Assets/SVG/TagIcon";

const New = () => {
    
    const { t } = useTranslation();
    
    const navigate = useNavigate();
    
    return (
        <PageLayout title={t('newTag')} icon={<TagIcon />} includeBox>
            <TagForm onSubmit={_ => navigate(-1)} />
        </PageLayout>
    )
}

export default New
